import { render, staticRenderFns } from "./CategoryUserAdd.vue?vue&type=template&id=24fb5e28"
import script from "./CategoryUserAdd.vue?vue&type=script&lang=js"
export * from "./CategoryUserAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports